import React from 'react';
import styled, {ThemeProvider} from "styled-components";
import {useServices} from "./hooks/use-services.hook";
import {observer} from "mobx-react";
import {AppLoadingIndicator} from "./app-loading-indicator";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { ScreenMediaQueriesChecksContext } from './react-contexts/scren-media-queries-checks.context';
import { ContainerMediaQueriesChecksContext } from './react-contexts/container-media-queries-checks.context';
import {SearchMaskComponent} from "./components/search-mask/search-mask.component";
import {OpenDialogsContainerComponent} from "./components/modal/open-dialogs-container.component";

const AppBox = styled.div`
    width: 100%;
`


export const  App: React.FC = observer(() => {
    const services = useServices();
    /*
    const appBoxRef = useRef<HTMLDivElement | null>(null);

    const containerMediaChecksRef = useRef(new ContainerMediaQueryChecks(services.screenMediaQuery));

    useEffect(() => {
        const containerMediaChecks = containerMediaChecksRef.current;
        if (appBoxRef.current) {
            containerMediaChecks.setElement(appBoxRef.current);
        }
        return () => {
            containerMediaChecks?.dispose();
        }
    }, []);
*/
    const renderContent = () => {
        if(services.isLoading) {
            return (<AppLoadingIndicator>
                {services.language.translate('Loading...')}
            </AppLoadingIndicator>)
        }

        return (<SearchMaskComponent/>);
    }

    return (
        <ScreenMediaQueriesChecksContext.Provider value={services.screenMediaQuery}>
            <AppBox>
                <ContainerMediaQueriesChecksContext.Provider value={services.screenMediaQuery}>
                    <ThemeProvider theme={services.theme.currentTheme}>
                        {services.theme.currentTheme.globalStyles}
                        {renderContent()}
                        <OpenDialogsContainerComponent/>

                    </ThemeProvider>
                </ContainerMediaQueriesChecksContext.Provider>
            </AppBox>

        </ScreenMediaQueriesChecksContext.Provider>
    );
});

export default App;
